import React from "react";

// Kitchen progress for one order or table, from useKitchenEta
const KitchenEtaBadge = ({ eta, className = "" }) => {
  if (!eta || eta.status === "served") return null;

  const minutes = eta.waitMin > 0 ? `~${eta.waitMin} min` : "any moment";
  const look = {
    new: ["bg-amber-100 text-amber-800", "⏳", `In kitchen queue · ready ${minutes}`],
    preparing: ["bg-blue-100 text-blue-800", "🍳", `Cooking · ready ${minutes}`],
    ready: ["bg-green-100 text-green-800", "✅", "Food ready"],
  }[eta.status];
  if (!look) return null;

  const [colors, icon, text] = look;
  const readyAt = eta.estReadyAt
    ? new Date(eta.estReadyAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
    : null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${colors} ${className}`}
      title={readyAt && eta.status !== "ready" ? `Estimated ready at ${readyAt}` : undefined}
    >
      <span aria-hidden="true">{icon}</span>
      {text}
    </span>
  );
};

export default KitchenEtaBadge;
